module.exports = __webpack_public_path__ + "static/media/4.80f50def.svg";